/*
 * @Author: Chris 
 * @Date: 2022-07-29 10:34:00 
 * @Last Modified by: Chris
 * @Last Modified time: 2022-10-08 17:26:10
 */

<template>
  <el-drawer
    :size="550"
    destroy-on-close
    :modal="false"
    @open="opendrawer"
    :visible.sync="show"
    :with-header="false"
    :before-close="closeDrawer"
  >
    <div class="drawer" v-loading="loading">
      <div class="drawer_header">
        <div class="header_title">
          {{title}}
          <div class="bgIMg"></div>
        </div>
        <i class="el-icon-close" @click="closeDrawer"></i>
      </div>
      <div class="drawer_body">
        <div class="drawer-content">
          <el-form
            :model="formdata"
            :rules="rules"
            ref="ruleForm"
            label-width="100px"
            class="demo-ruleForm">
            
            <el-form-item label="类型" prop="type">
              <el-radio-group v-model="formdata.type">
                <el-radio :label="0">菜单</el-radio>
                <el-radio :label="1">按钮</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="菜单名称" prop="permissionName">
              <el-input v-model="formdata.permissionName" placeholder="请填写菜单名称"></el-input>
            </el-form-item>

            <el-form-item label="上级菜单">
              <el-select
                class="select-tree-menu"
                ref="selectTree"
                popper-class="select-tree-menu-popper"
                v-model="formdata.parentId"
                placeholder="请选择上级菜单">
                <el-option
                  v-for="item in selectOptions"
                  :key="item.id"
                  :label="item.permissionName"
                  :value="item.id"
                  style="display: none;"></el-option>
                <el-option
                  :key="'none'"
                  label="无"
                  :value="-1"></el-option>
                <el-option value="tree">
                  <el-tree
                    class="main-select-el-tree"
                    ref="selecteltree"
                    :highlight-current="true"
                    :data="treeData"
                    :props="defaultProps"
                    :expand-on-click-node="false"
                    node-key="id"
                    @current-change="handleNodeClick"
                    :current-node-key="formdata.parentId"
                    :default-expanded-keys="formdata.parentId ? [formdata.parentId] : []" />
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="所属公司类型" prop="companyType">
              <el-radio-group v-model="formdata.companyType">
                <el-radio
                  v-for="item in companyTypeList"
                  :key="item.id"
                  :label="item.id">{{item.unitName}}</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="是否可分配" prop="distributable">
              <el-radio-group v-model="formdata.distributable">
                <el-radio :label="0">是</el-radio>
                <el-radio :label="1">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="授权标识" prop="permissionCode">
              <el-input v-model="formdata.permissionCode" placeholder="请填写授权标识"></el-input>
            </el-form-item>

            <el-form-item label="路由地址" prop="uri">
              <el-input v-model="formdata.uri" placeholder="请填写路由地址"></el-input>
            </el-form-item>

            <el-form-item label="是否外链" prop="linke">
              <el-radio-group v-model="formdata.linke">
                <el-radio :label="1">是</el-radio>
                <el-radio :label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="排序号" prop="sort">
              <el-input v-model="formdata.sort" placeholder="请填写排序号"></el-input>
            </el-form-item>

            <el-form-item label="菜单图标">
              <el-input v-model="formdata.icon" placeholder="请填写菜单图标名称"></el-input>
              <!-- <el-upload
                :action="'/basic/uploadImage'"
                :http-request="handleImageUpload"
                :show-file-list="false">
                <div class="upload_x">
                  <el-icon class="el-icon-plus avatar-uploader-icon"></el-icon>
                </div>
              </el-upload> -->
            </el-form-item>
          </el-form>
        </div>
        <div class="bottom_button">
          <div class="buttom_Del marin_l" @click="onSubmit">确定</div>
        </div>
      </div>
    </div>
  </el-drawer>
</template>

<script>
import {
  menuAdd,
  menuEdit,
  // getQiniuToken
} from "../../../api/api";
import axios from "axios";
import { getSuffix, getRandomStr } from '@/utils/tools.js'

export default {
  name: "modifyCompanyInformation",
  props: ["row", "type", "show", "treeData", "permissionType", "unitCode", "companyTypeList"],
  data() {
    return {
      formdata: {
        type: 0,
        parentId: -1,
        parentName: '',
        distributable: 0,
        permissionName: '',
        permissionCode: '',
        permissionType: 0,
        companyType: 0,
        uri: '',
        linke: 0,
        sort: 0,
        icon: ''
      }, //信息
      title: '新增菜单',
      rules: {
        type: [
          { required: true, message: '请输入菜单类型', trigger: 'change' }
        ],
        permissionName: [
          { required: true, message: '请输入菜单名称', trigger: 'change' }
        ],
        distributable: [
          { required: true, message: '请选择是否可分配', trigger: 'change' }
        ],
        permissionCode: [
          { required: true, message: '请输入授权标识', trigger: 'change' }
        ],
        // uri: [
        //   { required: true, message: '请填写路由地址', trigger: 'change' }
        // ],
        linke: [
          { required: true, message: '请选择是否外链', trigger: 'change' }
        ]
      },

      selectOptions: [],
      defaultProps: {
        label: 'permissionName',
        children: 'children'
      },

      // 上传图片token
      accessToken: null,

      loading: false,
    };
  },
  methods: {
    /**
     * 抽屉打开时，回显值
     * */
    opendrawer() {
      if (this.type == 'add') {
        this.title = '新增菜单';
        if (this.row) {
          this.title = '新增子菜单';
          this.formdata.id = null;
          this.formdata.parentId = this.row.id;
          this.formdata.parentName = this.row.permissionName;
          this.formdata.companyType = parseInt(this.unitCode)
          this.selectOptions = [
            {
              id: this.row.id,
              permissionName: this.row.permissionName || ''
            }
          ]
        } else {
          this.selectOptions = [];
          this.formdata.parentId = -1;
          this.formdata.companyType = parseInt(this.unitCode)
        }
      } else {
        this.title = '编辑菜单';
        this.formdata.id = this.row.id;
        this.formdata.parentId = this.row.parentId;
        this.formdata.parentName = this.row.parentName;
        this.selectOptions = [
          {
            id: this.row.parentId,
            permissionName: this.row.parentName || ''
          }
        ]
        this.formdata.permissionName = this.row.permissionName;
        this.formdata.permissionCode = this.row.permissionCode;
        this.formdata.permissionType = this.row.permissionType || 0;
        this.formdata.distributable = this.row.distributable;
        this.formdata.type = this.row.type;
        this.formdata.companyType = parseInt(this.row.unitCode);
        this.formdata.uri = this.row.uri;
        this.formdata.icon = this.row.icon;
        this.formdata.sort = this.row.sort;
        this.formdata.linke = this.row.linke;
      }
      // 页面打开重新获取上传token
      // this.getToken()
    },

    // 选择父级菜单
    handleNodeClick (node) {
      console.log('选择父级菜单:', node)
      this.$emit('treeChange', node)
      this.formdata.parentId = node.id;
      this.selectOptions = [node]
      this.$refs.selectTree.blur()
    },

    // 菜单图标
    // 获取上传token
    getToken() {
      // 获取七牛token
      getQiniuToken().then(res => {
        if (res.status === 0) {
          this.accessToken = res.result || '';
        }
      })
    },
    // 现场照片
    beforeUpload(file) {
      const isLt = file.size / 1024 / 1024 < 1;
      if(!isLt) {
        this.$message.error("图片大小不能超过1MB!");
      }
      return isLt;
    },
    // 上传文件
    handleImageUpload(e, a) {
      if (!this.beforeUpload(e.file)) {
        return
      }
      console.log(e, process.env.VUE_APP_QINIU);
      const date = new Date().getTime();
      const key = 'menu_icon/' + date + getRandomStr(8) + getSuffix(e.file.name || '')
			const remotePath = process.env.VUE_APP_QINIU_DOWNLOAD + '/' + key;

      const form = new FormData();
      form.append('file', e.file);
      form.append('key', key);
      form.append('token', this.accessToken);
      axios({
        method: 'post',
        url: process.env.VUE_APP_QINIU,
        data: form,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      }).then(res => {
        console.log(res)
        this.formdata.icon = remotePath;
      })
    },

    /**
     * 点击确定
     * */
    async onSubmit() {
      this.$refs.ruleForm.validate(async (valid) => {
        if (valid) {
          if (this.loading) {
            return
          }
          this.loading = true;

          let params = {
            ...this.formdata,
            permissionType: this.formdata.permissionType || this.permissionType || 0,
            unitCode: this.formdata.companyType
          };

          console.log('params:', params)
          try {
            let res = {}
            if (params.id) {
              res = await menuEdit(params)
            } else {
              res = await menuAdd(params)
            }
            console.log(res)
            if (res.code == 200) {
              this.$notify.success({
                title: "成功",
                message: res.msg,
              });
              this.$emit("getMenuListMethods");
              this.closeDrawer();
            }
            this.loading = false;
          } catch (error) {
            console.log(error);
            this.loading = false;
          }
        }
      });
    },

    /**
     * 关闭抽屉
     * */

    closeDrawer() {
      this.formdata = {
        type: 0,
        parentId: -1,
        parentName: '',
        distributable: 0,
        permissionName: '',
        permissionCode: '',
        permissionType: 0,
        companyType: 0,
        uri: '',
        linke: 0,
        sort: 0,
        icon: ''
      };
      this.selectOptions = []
      this.$emit('update:show', false);
    },
  },
};
</script>

<style lang="scss" scoped>
.drawer {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  position: relative;
  .drawer_header {
    cursor: pointer;
    user-select: none;
    border-bottom: 0.125rem solid #eeeeee;
    height: 3.375rem;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 1.25rem;
    box-sizing: border-box;
    .header_title {
      font-weight: 400;
      font-size: 1rem;
      position: relative;
      .bgIMg {
        position: absolute;
        bottom: 0;
        left: -0.5rem;
        width: 6.25rem;
        height: 0.625rem;
        background: linear-gradient(
          90deg,
          rgba(183, 40, 45, 0.3) 0%,
          rgba(183, 40, 45, 0.018) 99.4%
        );
        border-radius: 0.5rem;
      }
    }
  }
  .drawer_body {
    display: flex;
    .drawer-content {
      padding: 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .select-tree-menu {
      width: 100%;
    }
    .upload_x {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 42px;
      height: 42px;
      border: 1px dashed #d9d9d9;
      &:hover {
        border-color: #b7282d;
      }
    }

    .bottom_button {
      left: 110px;
      bottom: 2rem;
      position: absolute;
      display: flex;
    }
    .marin_l {
      margin-left: 0.75rem;
    }
  }
}
.select-tree-menu-popper {
  .el-select-.el-scrollbar__wrap {
    height: 340px;
    overflow-y: auto;
  }
  .el-select-dropdown__item {
    padding: 0;
    height: auto;
  }
}
</style>